const API_KEY = 'a31ff5f4e57ee3a7d71b781e537b022a';
// const Genre_ID = "";


export default {

    fetchTrending: `/trending/all/week?api_key=${API_KEY}&language=en-US`,

    fetchTrendingMovie: `/trending/movie/week?api_key=${API_KEY}&language=en-US`,
    fetchTrendingTV: `/trending/tv/week?api_key=${API_KEY}&language=en-US`,

    fetchMovie: `/trending/movie/day?api_key=${API_KEY}&language=en-US`,
    fetchTV: `/trending/tv/day?api_key=${API_KEY}&language=en-US`,

    fetchPerson: `/trending/person/day?api_key=${API_KEY}&language=en-US`,

    fetchPopular: `/movie/popular?api_key=${API_KEY}&language=en-US&page=1`,
    fetchTopRated: `/movie/top_rated?api_key=${API_KEY}&language=en-US`,

    fetchActionMovies: `/discover/movie?api_key=${API_KEY}&with_genres=28`,
    fetchAdventureMovies: `/discover/movie?api_key=${API_KEY}&with_genres=12`,
    fetchAnimation: `/discover/movie?api_key=${API_KEY}&with_genres=16`,
    fetchComedyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=35`,
    fetchCrimeMovies: `/discover/movie?api_key=${API_KEY}&with_genres=80`,
    fetchDocuMovies: `/discover/movie?api_key=${API_KEY}&with_genres=99`,
    fetchDramaMovies: `/discover/movie?api_key=${API_KEY}&with_genres=18`,
    fetchFamilyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10751`,
    fetchHistoryMovies: `/discover/movie?api_key=${API_KEY}&with_genres=36`,
    fetchHorrorMovies: `/discover/movie?api_key=${API_KEY}&with_genres=27`,
    fetchMusicMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10402`,
    fetchMystery: `/discover/movie?api_key=${API_KEY}&with_genres=9648`,
    fetchRomanceMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10749`,
    fetchSciFi: `/discover/movie?api_key=${API_KEY}&with_genres=878`,
    fetchThrilerMovies: `/discover/movie?api_key=${API_KEY}&with_genres=53`,
    fetchWarMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10752`,

    fetchGenre: `/genre/movie/list?api_key=${API_KEY}&language=en-US`,

    fetchNetflixOriginals: `/discover/tv?api_key=${API_KEY}&with_networks=213`,
    fetchCBS: `/discover/tv?api_key=${API_KEY}&with_networks=16`,
    fetchABC: `/discover/tv?api_key=${API_KEY}&with_networks=18`,
    fetchFOX: `/discover/tv?api_key=${API_KEY}&with_networks=19`,
    fetchUSANet: `/discover/tv?api_key=${API_KEY}&with_networks=30`,
    fetchMTV: `/discover/tv?api_key=${API_KEY}&with_networks=33`,
    fetchHBO: `/discover/tv?api_key=${API_KEY}&with_networks=49`,
    fetchDisney: `/discover/tv?api_key=${API_KEY}&with_networks=54`,
    fetchHistory: `/discover/tv?api_key=${API_KEY}&with_networks=65`,
    fetchHulu: `/discover/tv?api_key=${API_KEY}&with_networks=453`,
    fetchAmazon: `/discover/tv?api_key=${API_KEY}&with_networks=1024`,
    fetchYoutubeOrg: `/discover/tv?api_key=${API_KEY}&with_networks=1436`,
    fetchSyFy: `/discover/tv?api_key=${API_KEY}&with_networks=77`,



    // fetchNetflixOriginals: `/discover/tv?api_key=${API_KEY}&with_networks=213`,
    // fetchDocumentaries: `/discover/movie?api_key=${API_KEY}&with_genres=99`,
    // fetchWestern: `/discover/movie?api_key=${API_KEY}&with_genres=37`,
    // fetchByID(): `/discover/movie?api_key=${API_KEY}&with_genres=${Genre_ID}`,
}
